import {ImageViewerDataVo} from '../../common/shared/api/gateway/viewer/ImageViewerDataVo.interface';
import {
  ImageViewerData,
  ReadType,
  ViewDirection,
  ViewerDataType,
} from '../generated/types';

export function createImageViewerData({
  download_data,
}: ImageViewerDataVo): ImageViewerData {
  const direction = download_data.members.direction;
  const orientation = download_data.members.orientation;
  const margin = download_data.members.margin;
  const _sAtsServerUrl = download_data.members.sAtsServerUrl;
  const sAtsServerUrl = _sAtsServerUrl.replace('http://', 'https://');
  return {
    type: ViewerDataType.ImageViewerData,
    imageDownloadData: {
      viewDirection:
        direction === '1' ? ViewDirection.Backward : ViewDirection.Forward,
      gapBetweenImages: margin === '1' ? true : false,
      readType:
        orientation === '1'
          ? ReadType.Page
          : orientation === '2'
            ? ReadType.Scroll
            : ReadType.Both,
      files: download_data.members.files.map(file => ({
        no: file.no,
        size: Number(file.size),
        secureUrl: `${sAtsServerUrl}${file.secureUrl}`,
        width: file.width,
        height: file.height,
      })),
      totalCount: download_data.members.totalCount,
      totalSize: download_data.members.totalSize,
    },
  };
}
